import React from 'react'

const Checkbox = (props) => {
  const checkboxOption = props.checkboxOption

  return (
    <div className="cars-filter-checkbox">
      { checkboxOption.length > 0 && (
        <div>
          <input id={checkboxOption} value={props.option} name={checkboxOption} type="checkbox" onChange={props.handleChange} checked={props.checked}/>
          <label htmlFor={checkboxOption}>{checkboxOption}</label>
        </div>
        )
      }
    </div>
  )
}

export default Checkbox
